// extracted by mini-css-extract-plugin
module.exports = {"containerTitle":"_PYIfoWl","title":"_26Ou8wtq"};